import {PATIENT_RUNTIME_FALLBACK_SOURCES} from './patientRuntimeFallbackSources.js';
import legacyRoles from '../data/job_roles.json' with {type:'json'};
import {normalizeRoleData} from './normalizeRoleData.js';
import {effectiveTranslation} from './effectiveTranslation.js';
import {sourceRevision} from './translationAssurance.js';
const roleByKey=new Map(legacyRoles.map(role=>[role.role_key||role.id,role]));
const at=(value,path)=>path.reduce((value,key)=>value?.[key],value);
const legacyFields={plainEnglishTitle:'plain_english_title',whenYouSeeThem:'when_you_see_them',
  trainingLevel:'training_level',experienceNeeded:'experience_needed',worksWith:'works_with',
  typicalSettings:'typical_settings',keyResponsibilities:'key_responsibilities',notQualifiedTo:'not_qualified_to',reportsTo:'reports_to'};
export function buildRuntimeFallbackTranslationRows(locale,knownRows=[],translated={}) {
  const known=new Map(knownRows.map(row=>[row.id,row]));
  return PATIENT_RUNTIME_FALLBACK_SOURCES.flatMap(source=>{
    const existing=known.get(source.id);
    if(existing) {
      if(existing.sourceText!==source.sourceText) throw new Error('Runtime fallback source now differs from canonical English: '+source.id);
      return [];
    }
    const [namespace,path]=source.id.split(':');
    let stored=translated[path]||'';
    if(!stored && namespace==='roles' && locale!=='en') {
      const [,key,field,...suffix]=path.split('.');
      const role=roleByKey.get(key);
      const legacyField=legacyFields[field]||field;
      const value=normalizeRoleData({...role,[legacyField]:role?.[legacyField+'_'+locale]||role?.[legacyField]});
      const leaf=at(value?.[legacyField],suffix);
      if(typeof leaf==='string') stored=leaf;
    }
    const effective=effectiveTranslation(locale,namespace,path,stored);
    return [{...source,namespace,path,sourceRevision:sourceRevision(source.id,source.sourceText),
      publicationTarget:'locale',runtimeFallbackSource:true,originalText:effective.value,
      rawLocaleText:translated[path]||'',provenance:effective.provenance}];
  });
}
